import { createFileRoute } from '@tanstack/react-router';
import { Logo } from '@/components/ui/Logo';

/**
 * Root: just the logo. Deliberately inert — no redirect to the sign-in page and
 * no "who am I" probe, so the public origin gives a passer-by nothing to act on.
 * Hosts navigate to /singnow directly; guests arrive via a join link or QR.
 */
export const Route = createFileRoute('/')({
  component: LandingPage,
});

function LandingPage() {
  return (
    <div className="flex min-h-full flex-col items-center justify-center px-6 py-12">
      <Logo />
    </div>
  );
}
